import { render, staticRenderFns } from "./TableCodigoServico.vue?vue&type=template&id=1fced7aa&scoped=true"
import script from "./TableCodigoServico.vue?vue&type=script&lang=js"
export * from "./TableCodigoServico.vue?vue&type=script&lang=js"
import style0 from "./TableCodigoServico.vue?vue&type=style&index=0&id=1fced7aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fced7aa",
  null
  
)

export default component.exports